export interface User {
  id: string;
  telegramId: number;
  telegramUsername?: string;
  bonusBalance: number;
  referralCode: string;
  isBlocked: boolean;
  isAdmin?: boolean;
  referrals?: User[];
}

export interface UcPackage {
  id: string;
  amount: number;
  price: number;
  bonusPoints: number;
  availableCodes?: number;
  selectedCodes?: number;
}

export interface Order {
  id: string;
  user: User;
  package: UcPackage;
  orderCode: string;
  amountUc: number;
  amountBonus: number;
  price: number;
  status: 'pending' | 'completed' | 'failed';
  paymentId?: string;
  paymentUrl?: string;
  createdAt: string;
}

export interface SpinReward {
  id: string;
  rewardType: 'uc' | 'discount';
  rewardAmount: number;
  probability: number;
  minPurchase: number;
  archived: boolean;
}

export interface SpinHistory {
  id: string;
  user: User;
  reward: SpinReward;
  claimed: boolean;
  bonusCost: number;
  createdAt: string;
  updatedAt: string;
  activationStarted: boolean;
  activationExpiry?: Date;
  appliedToOrderId?: string;
  pendingUntil?: string; 
  orderId?: string; 
}

export interface SpinResult {
  success: boolean;
  reward?: {
    type: string;
    amount: number;
    minPurchase?: number;
  };
  message?: string;
  remainingBonusBalance?: number;
}

export enum PopularityItemType {
  PP_BUNDLE = 'pp_bundle',
  SPECIAL_ITEM = 'special_item',
}

export interface PopularityItem {
  id: string;
  itemType: PopularityItemType;
  ppAmount: number;
  name: string;
  nameEn: string;
  price: number;
  imageName: string;
  bonusPoints: number;
  isMergeable: boolean;
  archived: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface SavedTargetId {
  id: string;
  targetId: string;
  createdAt: string;
}

export interface PopularityCartItem {
  item: PopularityItem;
  quantity: number;
}
